import React from 'react';
import { Radio } from 'antd';
import { RadioProps } from 'antd/lib/radio';

export type { RadioProps };

const ProRadio: React.FC<RadioProps> = React.forwardRef<any, RadioProps>(
  (props, ref) => {
    const { children, ...resProps } = props;

    return (
      <Radio ref={ref} {...resProps}>
        {children}
      </Radio>
    );
  },
);

export default ProRadio;
